<template>
  <div
    :class="[
      'b-skeleton',
      {
        [`b-skeleton-${type}`]: true,
        [`b-skeleton-animate-${animation}`]: animation,
        [`b-skeleton-${variant}`]: variant
      }
    ]"
    :style="{
      width: size ?? width,
      height: size ?? height
    }"
  />
</template>

<script>
export default {
  name: 'BSkeleton',
  props: {
    variant: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    animation: {
      type: String,
      default: 'wave'
    },
    size: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@ui/styles/src/scss/utils/lib";

.b-skeleton {
  &.b-skeleton-dark {
    background-color: $grey-30;

    &.b-skeleton-input {
      border: none;
    }

    &.b-skeleton-animate-wave::after {
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.05), transparent)
    }
  }

}
</style>
